import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosClient from './axiosClient'

export const registerUser = createAsyncThunk(
  'auth/register',
  async (userData, { rejectWithValue }) => {
    try {
    const response =  await axiosClient.post('/user/register', userData);
    return response.data.user;
    } catch (error) {
       return rejectWithValue({ message: error.response?.data?.message || 'Login failed' });
    }
  }
);


export const loginUser = createAsyncThunk(
  'auth/login',
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post('/user/login', credentials);
      return response.data.user;
    } catch (error) {
     return rejectWithValue({ message: error.response?.data?.message || 'Auth check failed' });
    }
  }
);

// export const checkAuth = createAsyncThunk(
//   'auth/check',
//   async (_, { rejectWithValue }) => {
//     try {
//       const { data } = await axiosClient.get('/user/check');
//       return data.user;
//     } catch (error) {
//       return rejectWithValue({ message: error.response?.data?.message || 'Auth check failed' });
//     }
//   }
// );

export const logoutUser = createAsyncThunk(
  'auth/logout',
  async (_, { rejectWithValue }) => {
    try {
      await axiosClient.post('/user/logout');
      return null;
    } catch (error) {
       return rejectWithValue({ message: error.response?.data?.message || 'Logout failed' });
    }
  }
);

export const registerAdmin=createAsyncThunk(
  'auth/register',
  async (userData, { rejectWithValue }) => {
    try {
    const response =  await axiosClient.post('/user/admin/registor', userData);
    return response.data.user;
    } catch (error) {
       return rejectWithValue({ message: error.response?.data?.message || 'Login failed' });
    }
  }
);

const authSlice = createSlice({
  name: 'auth',
  initialState: {
  user:  null,
  isAuthenticated:false,
  loading: false,
  error: null
  },
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      // Register User Cases
      .addCase(registerUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.loading = false;
        state.isAuthenticated = !!action.payload;
       state.user = action.payload
      
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Something went wrong';
        state.isAuthenticated = false;
        state.user = null;
      })
  
      // Login User Cases
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.isAuthenticated = !!action.payload;
      
     state.user = action.payload
     
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Something went wrong';
        state.isAuthenticated = false;
        state.user = null;
      })
  
      // Check Auth Cases
      // .addCase(checkAuth.pending, (state) => {
      //   state.loading = true;
      //   state.error = null;
      // })
      // .addCase(checkAuth.fulfilled, (state, action) => {
      //   state.loading = false;
      //   state.isAuthenticated = !!action.payload;
      // state.user = action.payload;
      
      // })
      // .addCase(checkAuth.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error = action.payload?.message || 'Something went wrong';
      //   state.isAuthenticated = false;
      //   state.user = null;
      // })
  
      // Logout User Cases
      .addCase(logoutUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(logoutUser.fulfilled, (state) => {
        state.loading = false;
        state.user = null;
        state.isAuthenticated = false;
        state.error = null;
          
      })
      .addCase(logoutUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Something went wrong';
        state.isAuthenticated = false;
        state.user = null;
      });
  }
});

// AsyncThunk to send startup data to backend
export const getRecommendation = createAsyncThunk(
  'auth/recommend',
  async (startupData, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post('/user/recommend', startupData);
      return response.data;
     console.log(response.data);
    } catch (error) {
      return rejectWithValue({ message: error.response?.data?.message || 'Recommendation failed' });
    }
  }
);

const recommendationSlice = createSlice({
  name: 'recommendation',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearRecommendation: (state) => {
      state.data = null;
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRecommendation.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.data = null;
      })
      .addCase(getRecommendation.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getRecommendation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Something went wrong';
        state.data = null;
      });
  },
});
export const { clearRecommendation } = recommendationSlice.actions;
export { recommendationSlice };

// Default export for auth slice
export default authSlice.reducer;